import { Modal, Text, ActionButton } from 'components/commons';
import { useApi } from 'hooks';
import locale from 'localization';
import React, { useCallback } from 'react';
import styles from './books-of-accounts-modal.module.scss';
import { handleRequest } from 'utils';
import { deleteTransactionByBatch } from 'apis/transaction.api';

const BooksOfAccountsStatusModal = ({ refetchTransactions, status, close, active, batchId }) => {
  const { request: deleteTransactionRequest, loading: deletingTransaction } = useApi({
    api: deleteTransactionByBatch
  });

  const deleteTransactionCb = useCallback(async () => {
    handleRequest(async () => {
      await deleteTransactionRequest(
        {
          batchId
        },
        () => deleteTransactionCb()
      );
      refetchTransactions();
      close();
    });
  }, [deleteTransactionRequest, batchId, refetchTransactions, close]);

  return (
    <Modal active={active} title={`Confirm to delete transaction`} close={close} className={styles.modal}>
      <div className={styles.content}>
        <Text align="center">
          Are you sure you want to proceed? Please note that all transactions in the selected batch will be removed.
        </Text>
      </div>
      <ActionButton
        right
        items={[
          {
            text: locale.cancel,
            onClick: close
          },
          {
            loading: deletingTransaction,
            onClick: deleteTransactionCb,
            text: 'Delete'
          }
        ]}
      />
    </Modal>
  );
};

export default BooksOfAccountsStatusModal;
